import { render, staticRenderFns } from "./emResourceDetail.vue?vue&type=template&id=35b694d0&scoped=true&"
import script from "./emResourceDetail.vue?vue&type=script&lang=js&"
export * from "./emResourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./emResourceDetail.vue?vue&type=style&index=0&id=35b694d0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b694d0",
  null
  
)

export default component.exports